import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';

const EnrollmentSuccess = () => {
  const [searchParams] = useSearchParams();
  const { user, refreshUser } = useAuth();
  const navigate = useNavigate();
  const [refreshing, setRefreshing] = useState(true);

  // Refresh user data to pick up the new studioId + enrollment
  useEffect(() => {
    const refresh = async () => {
      // Give the webhook a moment to process
      await new Promise(resolve => setTimeout(resolve, 2000));
      await refreshUser();
      setRefreshing(false);
    };
    refresh();
  }, [refreshUser]);

  // Get course info from URL params (passed by enrollment page)
  const courseName = searchParams.get('course') || '';
  const schedule = searchParams.get('schedule') || '';

  const handleGoDashboard = async () => {
    // Refresh one more time to ensure studioId is set
    await refreshUser();
    // Route based on role
    if (user?.role === 'student') {
      navigate('/student');
    } else {
      navigate('/dashboard');
    }
  };

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center p-6">
      <div className="bg-white rounded-xl shadow-sm border border-gray-100 p-8 max-w-md w-full text-center">
        <div className="text-4xl mb-4">&#9989;</div>
        <h1 className="text-2xl font-bold text-gray-900 mb-2">You're enrolled!</h1>
        {courseName && (
          <p className="text-lg font-medium text-gray-700 mb-1">{courseName}</p>
        )}
        {schedule && (
          <p className="text-sm text-gray-500 mb-4">{schedule}</p>
        )}
        <p className="text-gray-500 mb-6">
          You'll receive an email with your class schedule and what to expect.
          Log in to your dashboard to see upcoming classes, access materials, and track your progress.
        </p>
        <button
          onClick={handleGoDashboard}
          disabled={refreshing}
          className="inline-block bg-brand-500 text-white px-6 py-2.5 rounded-lg font-medium hover:bg-brand-600 disabled:bg-gray-300 transition-colors"
        >
          {refreshing ? 'Setting up your dashboard...' : 'Go to Dashboard'}
        </button>
      </div>
    </div>
  );
};

export default EnrollmentSuccess;
